import { render, staticRenderFns } from "./EditPerDocumentStockSettingsModal.vue?vue&type=template&id=1e7f8c6f"
import script from "./EditPerDocumentStockSettingsModal.vue?vue&type=script&lang=ts"
export * from "./EditPerDocumentStockSettingsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports